<template>
  <div class="inside_pages_right" style="background: #f5f5f7;">
    <!-- <div class="inside_pages_right_top" style="background: #fff;">
      <div class="inside_header_title">
        基础信息
      </div>
    </div> -->
    <div class="school_pages_box" style="height:calc(100% - 10px)">
      <div class="school_info_box">
        <div class="title_box">
          <div class="title_icon"></div>
          <div class="title_text">基本信息</div>
        </div>
        <el-tooltip
          content="点击编辑"
          placement="top"
          effect="light"
          :disabled="!isEditInfo ? false : true"
        >
          <div
            :class="
              !isEditInfo ? 'info_content_box_one' : 'info_content_box_two'
            "
            @click="editClick"
          >
            <div
              class="info_item"
              v-for="(item, index) in baseInfoList"
              :key="index"
            >
              <span class="info_item_title">{{ item.title }}</span>
              <div class="info_item_content" v-if="!isEditInfo">
                <span v-if="item.type == 'time'">{{ schoolInfo[item.id] ? $Common.timeStampToDate(schoolInfo[item.id]) : ''}}</span>
                <span v-else-if="item.type == 'select'">{{$Common.getDataName(item.selectData,schoolInfo[item.id])}}</span>
                <div v-else>{{ schoolInfo[item.id] }}
                  <span v-if="item.unit">{{ item.unit }}</span>
                </div>
              </div>
              <div v-else>
                <el-input
                  v-if="item.type == 'input'"
                  class="info_item_input input-button"
                  v-model.trim="schoolInfo[item.id]"
                  :placeholder="'请输入' + item.title"
                  size="small"
                  clearable
                >
                  <template slot="append" size="small" v-if="item.unit">{{
                    item.unit
                  }}</template>
                </el-input>
                 <el-input
                  v-if="item.type == 'numberInput'"
                  class="info_item_input input-button"
                  v-model.trim="schoolInfo[item.id]"
                  :placeholder="'请输入' + item.title"
                  size="small"
                  clearable
                >
                  <template slot="append" size="small" v-if="item.unit">{{
                    item.unit
                  }}</template>
                </el-input>
                <el-date-picker
                  v-if="item.type == 'time'"
                  style="width:100%"
                  v-model="schoolInfo[item.id]"
                  value-format="timestamp"
                  type="date"
                  size="small"
                  :placeholder="'请选择' + item.title"
                >
                </el-date-picker>
                <el-select
                  v-model="schoolInfo[item.id]"
                  v-if="item.type == 'select'"
                  size="small"
                  style="width:100%"
                  :placeholder="'请选择' + item.title"
                >
                  <el-option
                    v-for="item in item.selectData"
                    :key="item.id"
                    :label="item.nameOne"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-input-number
                  v-model.trim="schoolInfo[item.id]"
                  v-if="item.type == 'number'"
                  size="small"
                  style="width:100%"
                  :min="1"
                ></el-input-number>
              </div>
              <!-- <div class="info_item_hr"></div> -->
            </div>
            <div class="info_item">
              <div class="info_item_title">LOGO:</div>
              <div class="info_item_logo" v-if="isEditInfo">
                <head-portrait-up-load
                  :imageUrl="schoolInfo.logUrl"
                  @imageChange="LogoImageChange"
                ></head-portrait-up-load>
              </div>
              <div
                class="info_item_content"
                v-else-if="!isEditInfo && !schoolInfo.logUrl"
              >
                暂无图片
              </div>
              <div class="info_item_content_img" v-else>
                <el-image
                  style="width:78px;height:78px"
                  :src="$store.state.config.fileUrl + schoolInfo.logUrl"
                >
                </el-image>
              </div>
              <!-- <div class="info_item_hr"></div> -->
            </div>
            <div class="info_item">
              <div class="info_item_title">安全信息公示二维码:</div>
              <div class="info_item_logo" v-if="isEditInfo">
                <head-portrait-up-load
                  :imageUrl="schoolInfo.securityInformationCodeUrl"
                  @imageChange="QRCodeChange"
                ></head-portrait-up-load>
              </div>
              <div
                class="info_item_content"
                v-else-if="
                  !isEditInfo && !schoolInfo.securityInformationCodeUrl
                "
              >
                暂无图片
              </div>
              <div class="info_item_content_img" v-else>
                <el-image
                  style="width:78px;height:78px"
                  :src="
                    $store.state.config.fileUrl +
                      schoolInfo.securityInformationCodeUrl
                  "
                >
                </el-image>
              </div>
              <!-- <div class="info_item_hr"></div> -->
            </div>
          </div>
        </el-tooltip>
        <div class="save_and_cencel_box" v-if="isEditInfo">
          <div class="btn_item" @click="setSchoolInfo">提交</div>
          <div class="btn_item" @click="cencelClick">取消</div>
        </div>
      </div>
      <div class="school_tabs_box" value="picture_info">
        <el-tabs type="border-card" name="picture_info">
          <el-tab-pane label="学校组织图">
            <div class="picture_info_box">
              <el-upload
                class="upload-demo picture_info_upload_box"
                action=""
                :show-file-list="false"
                accept="image/jpg, image/gif,image/png, image/jpeg"
                :http-request="handleAvatarSuccess"
              >
                <el-image
                  v-if="architectureDiagram.imgUrl"
                  :src="
                    $store.state.config.fileUrl + architectureDiagram.imgUrl
                  "
                >
                </el-image>
                <el-button
                  size="small"
                  type="primary"
                  class="el-icon-upload2"
                  v-else
                  >点击上传</el-button
                >
              </el-upload>
            </div>
          </el-tab-pane>
          <el-tab-pane label="管理层架构">
            <div class="framework_table_box">
              <el-table
                :data="organizationalStructure"
                height="100%"
            :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
              >
                <el-table-column
                  label="序号"
                  width="70"
                  align="center"
                  type="index"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="position"
                  label="职务"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <!-- <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.position"
                      placeholder="请输入职务"
                      size="mini"
                      clearable
                    ></el-input> -->
                    <span>{{ scope.row.position }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="name"
                  label="姓名"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.name"
                      placeholder="请输入姓名"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="phone"
                  label="手机号码"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.phone"
                      placeholder="请输入手机号码"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.phone }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="telephone"
                  label="固定电话"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.telephone"
                      placeholder="请输入固定电话"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.telephone }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="remark"
                  label="备注"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <el-input
                      v-if="scope.row.isEdit"
                      style="width:95%"
                      v-model.trim="scope.row.remark"
                      placeholder="请输入备注"
                      size="mini"
                      clearable
                    ></el-input>
                    <span v-else>{{ scope.row.remark }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                  <template slot-scope="scope">
                    <el-link
                      v-if="!scope.row.isEdit"
                  type="primary"
                      @click="editRow(scope.$index,scope.row)"
                  :underline="false"
                  >编辑</el-link
                >
                <el-link
                      v-if="scope.row.isEdit"
                  type="primary"
                      @click="editOrganizationFramework(scope.row)"
                  :underline="false"
                  >提交</el-link
                >
                <el-divider direction="vertical"
                      v-if="scope.row.isEdit"></el-divider>
                <el-link
                      v-if="scope.row.isEdit"
                  type="primary"
                      @click="centerEdit"
                  :underline="false"
                  >取消</el-link
                >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资质证书">
            <div class="certificate-box">
              <div v-if="certificateList && certificateList.length == 0">
                <el-upload
                  class="upload-demo"
                  action=""
                  :show-file-list="false"
                  accept="image/jpg, image/gif,image/png, image/jpeg"
                  :http-request="certificateSuccess"
                >
                  <el-button
                    size="small"
                    type="primary"
                    class="el-icon-upload2"
                    plain
                    >点击上传</el-button
                  >
                </el-upload>
              </div>
              <div class="have-data-upload-box" v-else>
                <div class="upload-btn-box" v-if="certificateList.length < 5">
                  <el-upload
                    class="upload-demo"
                    action=""
                    :show-file-list="false"
                    accept="image/jpg, image/gif,image/png, image/jpeg"
                    :http-request="certificateSuccess"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      class="el-icon-upload2"
                      plain
                      >点击上传</el-button
                    >
                  </el-upload>
                </div>
                <el-tooltip content="双击删除" placement="top" effect="light">
                  <el-carousel
                    :interval="10000"
                    arrow="always"
                    :type="certificateList.length < 3 ? '' : 'card'"
                    class="carousel-box"
                  >
                    <el-carousel-item
                      v-for="(item, index) in certificateList"
                      :key="index"
                      @dblclick.native="delSchoolCertificate(item.id)"
                    >
                      <img
                        :src="
                          $store.state.config.fileUrl + item.certificateImgUrl
                        "
                        alt=""
                      />
                    </el-carousel-item>
                  </el-carousel>
                </el-tooltip>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="通讯录及其他">
            <div class="row">
              <div class="col-sm-12">
                <div class="row top_padding">
                  <div class="col-sm-2" v-if="workFileData.length < 5">
                    <label for="mailListFile">
                      <input
                        type="file"
                        id="mailListFile"
                        @change="imgUpload($event, 5)"
                      />
                      <span class="btn btn-default btn-block">
                        点击上传
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <el-table :data="workFileData" 
            :header-cell-style="{ background: '#E2EEFF', color: '#474859' }">
                  <el-table-column
                    label="序号"
                    type="index"
                    align="center"
                    width="70"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="fileName"
                    label="文件名称"
                    align="center"
                  >
                    <template slot-scope="rowData">
                      {{ $Common.getFileName(rowData.row.fileName) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="fileSize"
                    label="文件大小"
                    align="center"
                    width="200"
                  >
                    <template slot-scope="rowData">
                      {{ $Common.fileSizeString(rowData.row.fileSize) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="scope">
                      <el-link
                        type="primary"
                        @click="$Common.fileDownloads(scope.row.fileName)"
                        :underline="false"
                        >下载</el-link
                      >
                      <el-divider direction="vertical"></el-divider>
                      <el-link
                        type="primary"
                        @click="delMailList(scope.row.id)"
                        :underline="false"
                        >删除</el-link
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  class="alert alert-warning"
                  style="margin-top:5px"
                  role="alert"
                >
                  备注：可最多上传5份文档。支持word/excel/pdf文件上传,大小不超过10MB
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "",
  components: {
    HeadPortraitUpLoad //200*200
  },
  props: {},
  data() {
    return {
      // 通讯录信息
      workFileData: [],

      // 学校基本信息
      schoolInfo: {
        schoolId: "",
        schoolName: "",
        schoolAddress: "",
        schoolCategory: "",
        schoolInstitutionCode: "",
        schoolFloorSpace: "",
        workCategory: "",
        numberFaculty: "",
        numberStudents: "",
        schoolPrincipal: "",
        establishmentTime: "",
        logUrl: "",
        vicePrincipal: "",
        vicePrincipalContactWay: "",
        securityInformationCodeUrl: ""
      },
      // 资质证书列表
      certificateList: [],
      certificatePreviewList: [], //资质证书放大列表
      // 当前操作的证书
      thisCertificateInfo: {
        certificateImgUrl: ""
      },
      // 学校组织架构图
      architectureDiagram: {
        id: "",
        imgUrl: ""
      },
      // 组织架构
      organizationalStructure: [],

      // 当前操作的通讯录
      thiMailList: {
        fileName: "",
        fileSize: 0
      },
      isEditInfo: false,
      baseInfoList: [
        { title: "机构名称:", id: "schoolName", type: "input" },
        { title: "机构代码:", id: "schoolInstitutionCode", type: "input" },
        { title: "创办时间:", id: "establishmentTime", type: "time" },
        {
          title: "建筑面积:",
          id: "schoolFloorSpace",
          type: "numberInput",
          unit: "㎡"
        },
        { title: "校长:", id: "schoolPrincipal", type: "input" },
        { title: "副校长:", id: "vicePrincipal", type: "input" },
        {
          title: "学校类别:",
          id: "schoolCategory",
          type: "select",
          selectData: this.$store.state.select.schoolCategory
        },
        {
          title: "办学类别:",
          id: "workCategory",
          type: "select",
          selectData: this.$store.state.select.schoolType
        },
        { title: "教职工人数:", id: "numberFaculty", type: "number",
          unit: "人" },
        { title: "学生人数:", id: "numberStudents", type: "number",
          unit: "人" },
        { title: "学校地址:", id: "schoolAddress", type: "input" },
        { title: "校方联系方式:", id: "vicePrincipalContactWay", type: "input" }
      ]
    };
  },
  watch: {},
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  methods: {
    // 获取通讯录及其它
    async getworkFileData() {
      var requestData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getMailList(requestData, true);
      if (res.code == 200) {
        // console.log(res.data)
        this.workFileData = res.data;
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 图片上传
    async imgUpload(event, cate = 1) {
      var uploadInfo = await this.$Common.fileUpload(event);
      if (uploadInfo) {
        switch (cate) {
          case 1: // 学校LOGO
            this.schoolInfo.logUrl = uploadInfo.fileUrl;
            break;
          case 2: // 公示二维码
            this.schoolInfo.securityInformationCodeUrl = uploadInfo.fileUrl;
            break;
          case 3: // 组织架构图
            this.architectureDiagram.imgUrl = uploadInfo.fileUrl;
            this.setOrganizationFrameworkPicture();
            break;
          case 4: // 资质证书
            this.thisCertificateInfo.certificateImgUrl = uploadInfo.fileUrl;
            this.addSchoolCertificate();
            break;
          case 5: // 通讯录及其它
            // console.log(uploadInfo)
            this.thiMailList.fileName = uploadInfo.fileUrl;
            this.thiMailList.fileSize = uploadInfo.fileSize;
            this.addMailList();
            break;
        }
      }
    },
    // 学校LOGO
    schoolInfoimgChange(src) {
      this.schoolInfo.logUrl = src || "";
    },
    // 安全信息公示二维码
    securityInformationCodeChange(src) {
      this.schoolInfo.securityInformationCodeUrl = src || "";
    },
    // 资质证书
    certificateimgChange(src) {
      this.thisCertificateInfo.certificateImgUrl = src || "";
      this.addSchoolCertificate();
    },
    // 获取学校资质证书
    async getSchoolCertificate() {
      var requestData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getSchoolCertificate(requestData, true);
      if (res.code == 200) {
        let data = res.data || [];
        let self = this;
        self.certificateList = data;
        self.certificatePreviewList = data.map((item) => {
          return self.$store.state.config.fileUrl + item.certificateImgUrl;
        });
      } else if (res.code == 101) {
        this.certificateList = [];
        this.certificatePreviewList = [];
      } else {
        this.certificateList = [];
        this.certificatePreviewList = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 添加通讯录及其它
    async addMailList() {
      var requestData = {
        schoolId: this.$store.state.schoolId,
        fileName: this.thiMailList.fileName,
        fileSize: this.thiMailList.fileSize
      };
      let res = await this.$Http.addMailList(requestData, true);
      if (res.code == 200) {
        this.thiMailList.fileName = "";
        this.thiMailList.fileSize = 0;
        // this.$message({
        //     message: res.messsage,
        //     type: 'success'
        // });
        this.getworkFileData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 获取学校信息
    async getSchoolInfo() {
      var requestData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getSchoolInfo(requestData, true);
      if (res.code == 200) {
        this.schoolInfo.schoolId = res.data.schoolId;
        this.schoolInfo.establishmentTime = res.data.establishmentTime * 1000;
        this.schoolInfo.schoolAddress = res.data.schoolAddress;
        this.schoolInfo.schoolName = res.data.schoolName;
        this.schoolInfo.schoolCategory = res.data.schoolCategory;
        this.schoolInfo.schoolInstitutionCode = res.data.schoolInstitutionCode;
        this.schoolInfo.schoolFloorSpace = res.data.schoolFloorSpace;
        this.schoolInfo.workCategory = res.data.workCategory;
        this.schoolInfo.numberFaculty = res.data.numberFaculty;
        this.schoolInfo.numberStudents = res.data.numberStudents;
        this.schoolInfo.schoolPrincipal = res.data.schoolPrincipal;
        this.schoolInfo.logUrl = res.data.logUrl;
        this.schoolInfo.vicePrincipal = res.data.vicePrincipal;
        this.schoolInfo.vicePrincipalContactWay =
          res.data.vicePrincipalContactWay;
        this.schoolInfo.securityInformationCodeUrl =
          res.data.securityInformationCodeUrl;
        // console.log(this.schoolInfo)
        // this.schoolInfo =  res.data
        this.$store.commit("updateSchoolInfo", res.data);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    },
    editRow(index,row) {
      // console.log(index,row);
      row.isEdit = true;
    },
    centerEdit() {
      this.getOrganizationFramework();
    },
    // 修改学校组织架构信息
    async editOrganizationFramework() {
      var requestData = this.organizationalStructure;
      let res = await this.$Http.editOrganizationFramework(requestData);
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.getOrganizationFramework();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 修改学校信息
    async setSchoolInfo() {
      var requestData = Object.assign({}, this.schoolInfo);
      // if(this.schoolInfo.schoolName == ''){
      //     this.$message('请输入学校名称！')
      //     return;
      // }
      if (requestData.numberFaculty == "") {
        requestData.numberFaculty = 0;
      }
      if (requestData.numberStudents == "") {
        requestData.numberStudents = 0;
      }
      // if(this.schoolInfo.schoolAddress == ''){
      //     this.$message('请输入学校地址！')
      //     return;
      // }

      requestData.establishmentTime = parseInt(
        requestData.establishmentTime / 1000
      );
      requestData.schoolFloorSpace= Math.round(requestData.schoolFloorSpace)
      let res = await this.$Http.setSchoolInfo(requestData, true);
      if (res.code == 200) {
        this.getSchoolInfo();

        this.isEditInfo = false;
        this.$message({
          message: res.messsage,
          type: "success"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 添加学校资质证书
    async addSchoolCertificate() {
      var requestData = {
        schoolId: this.$store.state.schoolId,
        certificateImgUrl: this.thisCertificateInfo.certificateImgUrl
      };
      let res = await this.$Http.addSchoolCertificate(requestData, true);
      if (res.code == 200) {
        this.thisCertificateInfo.certificateImgUrl = "";
        // this.$message({
        //     message: res.messsage,
        //     type: 'success'
        // });
        this.getSchoolCertificate();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 删除学校资质证书
    async delSchoolCertificate(thisid) {
      this.$confirm("此操作将永久删除此图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            id: thisid
          };
          let res = await this.$Http.delSchoolCertificate(requestData, true);

          if (res.code == 200) {
            this.getSchoolCertificate();
            this.$message({
              message: res.messsage,
              type: "success"
            });
          } else if (res.code == 101) {
          } else {
            this.$message({
              message: res.messsage,
              type: "error"
            });
          }
        })
        .catch(() => {});
    },

    // 删除学校通讯录
    async delMailList(thisid) {
      this.$confirm("此操作将永久删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            id: thisid
          };
          let res = await this.$Http.delMailList(requestData, true);
          if (res.code == 200) {
            this.getworkFileData();
            this.$message({
              message: res.messsage,
              type: "success"
            });
          } else if (res.code == 101) {
          } else {
            this.$message({
              message: res.messsage,
              type: "error"
            });
          }
        })
        .catch(() => {});
    },

    // 获取学校组织架构图
    async getOrganizationFrameworkPicture() {
      var requestData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getOrganizationFrameworkPicture(
        requestData,
        true
      );
      if (res.code == 200) {
        this.architectureDiagram.id = res.data.id;
        this.architectureDiagram.imgUrl = res.data.imgUrl;
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 获取学校领导组织架构
    async getOrganizationFramework() {
      var requestData = {
        schoolId:Number(this.$store.state.schoolId)
      };
      let res = await this.$Http.getOrganizationFramework(requestData);
      if (res.code == 200) {
        // console.log(res.data)
        let data = res.data;
        this.organizationalStructure = data.map((item) => {
          item.isEdit = false;
          return item;
        });
      } else if (res.code == 101) {
        this.organizationalStructure = [];
      } else {
        this.organizationalStructure = [];
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    },

    // 更改学校组织架构图
    async setOrganizationFrameworkPicture() {
      var requestData = this.architectureDiagram;
      let res = await this.$Http.setOrganizationFrameworkPicture(
        requestData,
        true
      );
      // console.log(res)
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    // 基本信息切换为编辑状态
    editClick() {
      this.isEditInfo = true;
    },
    // 基本信息编辑取消
    cencelClick() {
      this.getSchoolInfo();
      this.isEditInfo = false;
    },
    LogoImageChange(src) {
      this.schoolInfo.logUrl = src || "";
    },
    QRCodeChange(src) {
      this.schoolInfo.securityInformationCodeUrl = src || "";
    },
    // 组织图上传成功
    async handleAvatarSuccess(event) {
      if (!this.architectureDiagram.id) {
        delete this.architectureDiagram.id;
      }
      let res = await this.$Common.fileUploadNew(event);
      this.architectureDiagram.imgUrl = res.fileUrl;
      this.setOrganizationFrameworkPicture();
    },
    async certificateSuccess(event) {
      let res = await this.$Common.fileUploadNew(event);
      this.thisCertificateInfo.certificateImgUrl = res.fileUrl;
      this.addSchoolCertificate();
    }
  },
  created() {
    this.getSchoolInfo();
    this.getworkFileData();
    this.getOrganizationFrameworkPicture();
    this.getOrganizationFramework();
    this.getSchoolCertificate();
  },
  mounted() {
    // this.schoolInfo = this.$Common.getSchoolInfo()
    // console.log( this.schoolInfo)
    // this.getSchoolInfo()
    // this.getworkFileData()
    // this.getOrganizationFrameworkPicture()
    // this.getOrganizationFramework()
    // this.getSchoolCertificate()
  }
};
</script>
<style scoped lang="scss">
@import "/css/base.css";
@import "/css/update_school_data.css";
.school-organization-img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.remove-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  background: url("~@/assets/img/img/delete-icon.png") center center no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.1);
  }
}
.school_pages_box {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  padding-top: 0;
  height: calc(100% - 71px);
  width: 100%;
}
.school_info_box {
  width: calc(25%);
  height: 100%;
  background: #fff;
  margin: 0px 5px;
  padding: 10px 20px;
}
.title_box {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: 30px;
  width: 120px;
  background: url("~@/assets/img/edu/edu_info_title_bg.png") center center
    no-repeat;
  background-size: 100% 100%;
  padding: 2px 10px;
  .title_icon {
    width: 26px;
    height: 26px;
    background: url("~@/assets/img/edu/base_info_icon.png") center center
      no-repeat;
    background-size: 100% 100%;
  }
  .title_text {
    margin-left: 10px;
    font-size: 14px;
    font-weight: bolder;
    color: rgba(71, 72, 89, 1);
  }
}
.info_content_box_one {
  width: 100%;
  margin: 10px 0px;
  height: calc(100% - 46px);
  overflow-y: scroll;
  cursor: pointer;
  scrollbar-width: none;
}
.info_content_box_two {
  width: 100%;
  margin: 10px 0px;
  height: calc(100% - 107px); //提交按钮60
  overflow-y: scroll;
  cursor: pointer;
  scrollbar-width: none;
}
.info_item {
  padding: 3px 0;
  overflow: hidden;
  border-top:0.5px solid #f1f0f0;
  .info_item_title {
    height:36px;
    line-height:36px;
    margin-left: 5px;
    font-size: 14px;
    color: #a5a5be;
    font-weight: 500;
    float:left;
    width:50%;
  }
  .info_item_content {
    width:45%;
    float:right;
    font-size: 15px;
    color: #474859;
    font-weight: 600;
    text-align: center;
    height: 36px;
    line-height: 36px;
  }
  .info_item_content_img {
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .info_item_logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 78px;
    width: 100%;
  }
  .info_item_input {
    // height: 36px;
    width: 100%;
  }
  .info_item_hr {
    width: 100%;
    height: 0.5px;
    margin: 2px 0px;
    background-color: #f1f0f0;
  }
}
.save_and_cencel_box {
  height: 60px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .btn_item {
    width: 90px;
    height: 30px;
    background: #179aff;
    box-shadow: 0px -2px 0px 0px #cde9ff;
    border-radius: 24px 6px 24px 6px;
    // border: 1px solid ##3eabff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: AlibabaPuHuiTiM;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      background: #3eabff;
    }
  }
}
.school_tabs_box {
  width: calc(75% - 10px);
  margin-bottom: 5px;
  height: 100%;
  position: relative;
  /deep/.el-tabs--border-card {
    color: red;
    height: 100%;
    .el-tabs__content {
      height: calc(100% - 40px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
.framework_table_box {
  width: 100%;
  height: 100%;
  padding: 5px;
}
.picture_info_box {
  width: 100%;
  height: 100%;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  .upload-box {
    width: 100%;
    height: 100%;
    .picture_img_box {
      width: 100%;
      height: 100%;
    }
  }
}
.certificate-box {
  width: 100%;
  height: 100%;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .have-data-upload-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    .upload-btn-box {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 20px;
    }
    .carousel-box {
      width: 95%;
      margin: 10px;
      height: calc(100% - 70px);
      /deep/.el-carousel__container {
        height: calc(100% - 30px);
        width: 100%;
      }
    }
  }
}
.el-carousel__item {
  background-color: rgba(228, 228, 228,0.6);
  display: flex;
  justify-content: center;
  align-content: center;
  border: 1px solid rgb(228, 228, 228);
  cursor: pointer;
}
.picture_info_upload_box{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-upload{
    height: 100%;
  }
}
.picture_info_upload_box /deep/ .el-upload{
  // height: 100%;
}
.picture_info_upload_box /deep/ .el-upload .el-image{
  height: 100%;
  width: 100%;
}
</style>
